<template>
  <Systems />
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import Systems from '@/app/features/ams/systems/SystemsView.vue';

  export default defineComponent({
    name: 'SystemsPage',
    components: {
      Systems,
    },
  });
</script>
